import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class VerifyAccountService {
  private baseUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient) { }

  verifyAccount(userToken: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/account/verify/${userToken}`);
  }
}
